import React from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../../Context';
import { useTranslation } from '../../TranslationContext';
import TermsAndConditions from './TermsAndConditions'; 

function TermsOverlay() {
	
	const { psServer, showTerms, setShowTerms, submittedCode, showTermsPopup, setShowTermsPopup } = useAppContext();
	const { t } = useTranslation();
	
	const handleAccept = async () => {
		try {
			const response = await fetch(`${psServer}/ui/customer/${submittedCode}/terms`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				}
			});
			const data = await response.json();
			if (data === "Success") {
				setShowTermsPopup(false);
			}
		} catch (error) {
			console.error('Error submitting data:', error);
		}
	};
	
	const handleShowTerms = () => {
		setShowTerms(true);
	};
	
	const handleClose = () => {
		setShowTerms(false);
	};
	
	return (
		<>
			{showTermsPopup && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5, ease: "easeInOut" }}
					className="termsOverlayWrap"
				>
					<div className="termsOverlay">
						<h3>{t('termsOverlayTitle')}</h3>
						<p>{t('termsOverlayMessage1a')} <span className="showTerms" onClick={handleShowTerms}>{t('termsOverlayMessage1b')}</span></p>
						<button onClick={handleAccept}>{t('buttonAccept')}</button>
					</div>
				</motion.div>
			)}
			{showTerms && (
				<motion.div
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
					transition={{ duration: 0.5, ease: "easeInOut" }}
					className="TermsAndConditions"
				>
					<div className="TermsAndConditionsClose" onClick={handleClose}>X</div>
					<div className="theTerms"><TermsAndConditions/></div>
				</motion.div>
			)}
		</>
	);
}

export default TermsOverlay;